import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { currentState, biologicEdge } from '../data/comparison';
export function BeforeAfter() {
  return <section className="py-20 md:py-24 px-4 bg-zinc-900/50 border-y border-white/5" data-id="element-15" data-mp="3ogaw1sku956d">
      <div className="max-w-5xl mx-auto" data-id="element-16" data-mp="3sh33cga5h000">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white text-center mb-12 md:mb-16 tracking-tight" data-id="element-17" data-mp="3sg1py55nw1f4">
          Most People Settle for a Broken System. You Don't Have To.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-18" data-mp="2vrm2qfq0y456">
          {/* The Current State */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-zinc-950 border border-white/10 rounded-2xl p-6 md:p-8" data-id="element-19" data-mp="30pdsb3375e67">
            <h3 className="text-lg md:text-xl font-bold text-gray-500 mb-6" data-id="element-20" data-mp="121txgs6eqw0g">
              The Current State (The Fog)
            </h3>
            <ul className="space-y-5" data-id="element-21" data-mp="9fr5gx7w5e91">
              {currentState.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-22" data-mp="o4dtrofhxgce">
                  <span className="mt-0.5 shrink-0 w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-23" data-mp="o5otnd5tm3y8">
                    <XIcon className="w-4 h-4 text-red-500" data-id="element-24" data-mp="3rsfgzkzae7zm" />
                  </span>
                  <p className="text-gray-400 leading-relaxed" data-id="element-25" data-mp="3mtvwzq49769w">
                    <span className="font-semibold text-gray-300" data-id="element-26" data-mp="3mtm3vtnwwizz">
                      {item.title}:
                    </span>{' '}
                    {item.description}
                  </p>
                </li>)}
            </ul>
          </motion.div>

          {/* The Biologic Edge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="bg-zinc-950 border-2 border-green-500 rounded-2xl p-6 md:p-8 shadow-[0_0_45px_rgba(34,197,94,0.25)]" data-id="element-27" data-mp="20infcisle4jx">
            <h3 className="text-lg md:text-xl font-bold text-green-400 mb-6" data-id="element-28" data-mp="1lsxzrijr5y04">
              The Biologic Edge (The Mastery)
            </h3>
            <ul className="space-y-5" data-id="element-29" data-mp="2x6jpb4tiy1m6">
              {biologicEdge.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-30" data-mp="37aqjunwwlzqm">
                  <span className="mt-0.5 shrink-0 w-6 h-6 rounded-full bg-green-500/10 flex items-center justify-center" data-id="element-31" data-mp="37cund4qw4wqd">
                    <CheckIcon className="w-4 h-4 text-green-400" data-id="element-32" data-mp="2xkx8no0obmmw" />
                  </span>
                  <p className="text-gray-400 leading-relaxed" data-id="element-33" data-mp="2xikm0xjz0o3i">
                    <span className="font-semibold text-white" data-id="element-34" data-mp="2titvmuycw9zi">
                      {item.title}:
                    </span>{' '}
                    {item.description}
                  </p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}